import React from 'react'
import { isMobile } from '../../../helpers/mobileresize/Mobileresize'
import WebcontrollerDashboard from './web/index'
import MobilecontrollerDashboard from './mobile/index'

const index = () =>{
    if(isMobile){
        return(
            <div>
                <MobilecontrollerDashboard />
            </div>
        )
    }else{
        return(
            <div>
                <WebcontrollerDashboard />
            </div>
        )
    }
}

export default index